import { e as n } from "./caml_obj-c29533cc.mjs";

import { e as t, s as e } from "./belt_Array-b9ebcaa6.mjs";

import { m as r, i as o } from "./belt_Option-91f3b350.mjs";

import { s as u, v as i } from "./caml_option-16487d6d.mjs";

import { i as c } from "./caml_js_exceptions-5c6894a5.mjs";

function treeHeight(n) {
  if (void 0 !== n) {
    return n.h;
  } else {
    return 0;
  }
}

function create(n, t, e, r) {
  var o = treeHeight(n);
  var u = treeHeight(r);
  return {
    k: t,
    v: e,
    h: o >= u ? o + 1 | 0 : u + 1 | 0,
    l: n,
    r
  };
}

function bal(n, t, e, r) {
  var o = void 0 !== n ? n.h : 0;
  var u = void 0 !== r ? r.h : 0;
  if (o > (u + 2 | 0)) {
    var i = n.l;
    var c = n.r;
    if (treeHeight(i) >= treeHeight(c)) {
      return create(i, n.k, n.v, create(c, t, e, r));
    } else {
      return create(create(i, n.k, n.v, c.l), c.k, c.v, create(c.r, t, e, r));
    }
  }
  if (u <= (o + 2 | 0)) {
    return {
      k: t,
      v: e,
      h: o >= u ? o + 1 | 0 : u + 1 | 0,
      l: n,
      r
    };
  }
  var a = r.l;
  var s = r.r;
  if (treeHeight(s) >= treeHeight(a)) {
    return create(create(n, t, e, a), r.k, r.v, s);
  } else {
    return create(create(n, t, e, a.l), a.k, a.v, create(a.r, r.k, r.v, s));
  }
}

function set(n, t, e) {
  if (void 0 === n) {
    return function singleton(n, t) {
      return {
        k: n,
        v: t,
        h: 1,
        l: void 0,
        r: void 0
      };
    }(t, e);
  }
  var r = n.k;
  if (t === r) {
    return function updateValue(n, t) {
      if (n.v === t) {
        return n;
      } else {
        return {
          k: n.k,
          v: t,
          h: n.h,
          l: n.l,
          r: n.r
        };
      }
    }(n, e);
  }
  var o = n.v;
  if (t < r) {
    return bal(set(n.l, t, e), r, o, n.r);
  } else {
    return bal(n.l, r, o, set(n.r, t, e));
  }
}

var a = function get$1(n, t) {
  while (1) {
    var e = n;
    if (void 0 === e) {
      return;
    }
    var r = e.k;
    if (t === r) {
      return u(e.v);
    }
    n = t < r ? e.l : e.r;
  }
};

function placeholder(n) {}

function identity(n) {
  return n;
}

var s = n;

function equals() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return s(t, n[0]);
    };
  }
  return s(arguments[0], arguments[1]);
}

function _both(n, t, e) {
  if (t(n)) {
    return e(n);
  } else {
    return !1;
  }
}

function both() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _both(t, n[0], n[1]);
    };
  }
  return _both(arguments[0], arguments[1], arguments[2]);
}

function _either(n, t, e) {
  if (t(n)) {
    return !0;
  } else {
    return e(n);
  }
}

function either() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _either(t, n[0], n[1]);
    };
  }
  return _either(arguments[0], arguments[1], arguments[2]);
}

function always(n) {
  return function() {
    return n;
  };
}

function _defaultTo(n, t) {
  if (null == n) {
    return t;
  } else {
    return n;
  }
}

function defaultTo() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _defaultTo(t, n[0]);
    };
  }
  return _defaultTo(arguments[0], arguments[1]);
}

function falsy() {
  return !1;
}

function truthy() {
  return !0;
}

function _ifElse(n, t, e, r) {
  if (t(n)) {
    return e(n);
  } else {
    return r(n);
  }
}

function ifElse() {
  if (3 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _ifElse(t, n[0], n[1], n[2]);
    };
  }
  return _ifElse(arguments[0], arguments[1], arguments[2], arguments[3]);
}

function ignore(n) {}

function _unless(n, t, e) {
  if (t(n)) {
    return n;
  } else {
    return e(n);
  }
}

function unless() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _unless(t, n[0], n[1]);
    };
  }
  return _unless(arguments[0], arguments[1], arguments[2]);
}

function _when_(n, t, e) {
  if (t(n)) {
    return e(n);
  } else {
    return n;
  }
}

function when() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _when_(t, n[0], n[1]);
    };
  }
  return _when_(arguments[0], arguments[1], arguments[2]);
}

function _allPass(n, e) {
  return t(e, (function(t) {
    return t(n);
  }));
}

function allPass() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _allPass(t, n[0]);
    };
  }
  return _allPass(arguments[0], arguments[1]);
}

function _anyPass(n, t) {
  return e(t, (function(t) {
    return t(n);
  }));
}

function anyPass() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _anyPass(t, n[0]);
    };
  }
  return _anyPass(arguments[0], arguments[1]);
}

function _tap(n, t) {
  t(n);
  return n;
}

function tap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _tap(t, n[0]);
    };
  }
  return _tap(arguments[0], arguments[1]);
}

function _makeControlledThrottle(n, t) {
  var e = {
    contents: !1
  };
  var o = {
    contents: void 0
  };
  var cancel = function(n) {
    r(o.contents, void 0, (function(n) {
      clearTimeout(n);
    }));
    o.contents = void 0;
  };
  var i = {
    contents: t.leading
  };
  return {
    cancel,
    invoke: function(...t) {
      cancel();
      n(...t);
    },
    isScheduled: function(n) {
      return e.contents;
    },
    schedule: function(...r) {
      if (i.contents) {
        i.contents = !1;
        return n(...r);
      } else {
        if (e.contents) {
          return;
        }
        cancel();
        e.contents = !0;
        n(...r);
        var c = setTimeout((function(n) {
          e.contents = !1;
          o.contents = void 0;
        }), t.delay);
        o.contents = u(c);
        return;
      }
    }
  };
}

function makeControlledThrottle() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _makeControlledThrottle(t, n[0]);
    };
  }
  return _makeControlledThrottle(arguments[0], arguments[1]);
}

function _throttle(n, t) {
  return makeControlledThrottle(n, {
    delay: t,
    leading: !1
  }).schedule;
}

function throttle() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _throttle(t, n[0]);
    };
  }
  return _throttle(arguments[0], arguments[1]);
}

function _makeControlledDebounce(n, t) {
  var e = {
    contents: void 0
  };
  var cancel = function(n) {
    r(e.contents, void 0, (function(n) {
      clearTimeout(n);
    }));
    e.contents = void 0;
  };
  var i = {
    contents: t.leading
  };
  return {
    cancel,
    invoke: function(...t) {
      cancel();
      n(...t);
    },
    isScheduled: function(n) {
      return o(e.contents);
    },
    schedule: function(...r) {
      if (i.contents) {
        i.contents = !1;
        return n(...r);
      } else {
        cancel();
        var o = setTimeout((function(t) {
          n(...r);
          e.contents = void 0;
        }), t.delay);
        e.contents = u(o);
        return;
      }
    }
  };
}

function makeControlledDebounce() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _makeControlledDebounce(t, n[0]);
    };
  }
  return _makeControlledDebounce(arguments[0], arguments[1]);
}

function _debounce(n, t) {
  return makeControlledDebounce(n, {
    delay: t,
    leading: !1
  }).schedule;
}

function debounce() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _debounce(t, n[0]);
    };
  }
  return _debounce(arguments[0], arguments[1]);
}

function _tryCatch(n, t) {
  try {
    return {
      TAG: 0,
      _0: t(n)
    };
  } catch (n) {
    var e = c(n);
    if ("JsError" === e.RE_EXN_ID) {
      return {
        TAG: 1,
        _0: e._1
      };
    } else {
      return {
        TAG: 1,
        _0: e
      };
    }
  }
}

function tryCatch() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _tryCatch(t, n[0]);
    };
  }
  return _tryCatch(arguments[0], arguments[1]);
}

function _before(n, t) {
  var e = {
    contents: 0
  };
  var r = {
    contents: void 0
  };
  return function(...o) {
    var c = r.contents;
    if (void 0 !== c) {
      if (e.contents >= n) {
        return i(c);
      }
      var a = t(...o);
      r.contents = u(a);
      e.contents = e.contents + 1 | 0;
      return a;
    }
    var s = t(...o);
    r.contents = u(s);
    e.contents = e.contents + 1 | 0;
    return s;
  };
}

function before() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _before(t, n[0]);
    };
  }
  return _before(arguments[0], arguments[1]);
}

function _after(n, t) {
  var e = {
    contents: 0
  };
  return function(...r) {
    if (e.contents < n) {
      e.contents = e.contents + 1 | 0;
      return;
    } else {
      return u(t(...r));
    }
  };
}

function after() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _after(t, n[0]);
    };
  }
  return _after(arguments[0], arguments[1]);
}

function once(n) {
  var t = {
    contents: void 0
  };
  return function(...e) {
    var r = t.contents;
    if (void 0 !== r) {
      return i(r);
    }
    var o = n(...e);
    t.contents = u(o);
    return o;
  };
}

var f = once;

function _memoizeWithKey(n, t) {
  var e = {
    contents: void 0
  };
  return function(...r) {
    var o = n(...r);
    var u = a(e.contents, o);
    if (void 0 !== u) {
      return i(u);
    }
    var c = t(...r);
    e.contents = set(e.contents, o, c);
    return c;
  };
}

function memoizeWithKey() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _memoizeWithKey(t, n[0]);
    };
  }
  return _memoizeWithKey(arguments[0], arguments[1]);
}

function toMutable(n) {
  return n;
}

function coerce(n) {
  return n;
}

function _andThen(n, t) {
  return t(n);
}

function andThen() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _andThen(t, n[0]);
    };
  }
  return _andThen(arguments[0], arguments[1]);
}

var l = {
  __proto__: null,
  placeholder,
  identity,
  equals,
  both,
  either,
  always,
  defaultTo,
  falsy,
  truthy,
  ifElse,
  ignore,
  unless,
  when,
  allPass,
  anyPass,
  tap,
  makeControlledThrottle,
  throttle,
  makeControlledDebounce,
  debounce,
  tryCatch,
  before,
  after,
  once,
  memoize: f,
  memoizeWithKey,
  toMutable,
  coerce,
  andThen
};

export { memoizeWithKey as A, toMutable as B, coerce as C, andThen as D, identity as a, both as b, either as c, always as d, equals as e, defaultTo as f, falsy as g, ifElse as h, l as i, ignore as j, allPass as k, anyPass as l, tap as m, makeControlledThrottle as n, throttle as o, placeholder as p, makeControlledDebounce as q, debounce as r, tryCatch as s, truthy as t, unless as u, before as v, when as w, after as x, once as y, f as z };
